module.exports = __webpack_public_path__ + "img/icon-tubiao.1bc2c0e2.svg";